import { Asset } from "../model/asset/asset"
import { useGetPaginatedAssetsInfiniteQuery } from "../client/mfh/mfhApi"
import { useEffect, useMemo } from "react"

export const useAssetsOfAccount = (): Asset[] => {
    const { data, fetchNextPage, hasNextPage, isSuccess } = useGetPaginatedAssetsInfiniteQuery()

    useEffect(() => {
        if (isSuccess && hasNextPage) {
            fetchNextPage()
        }
    }, [isSuccess, hasNextPage, fetchNextPage])

    return useMemo(() => {
        if (!data) return []
        return data.pages
            .flatMap(page => page.items)
            .sort((a, b) => a.name.localeCompare(b.name))
    }, [data])
}